<ngx-skeleton-loader *ngIf="initialLoading" count="5"
  [theme]="{ 'border-radius': '8px', height: '60px', margin: '10px 40px 0px', width: 'calc(100% - 80px)' }"></ngx-skeleton-loader>
<div *ngIf="!initialLoading" #top class="container">
  <div *ngIf="!fromSearch || (fromSearch && templateList.length > 0)" infiniteScroll immediateCheck="true"
    [fromRoot]="listService.fromRoot" (scrolled)="listService.getList()"
    [infiniteScrollDistance]="listService.scrollDistance" [infiniteScrollThrottle]="listService.scrollThrottle"
    [infiniteScrollContainer]="listService.scrollContainer"
    [infiniteScrollDisabled]="this.scrollDisabled || listService.scrollDisabled">
    <div class="download-banner" *ngIf="!fromSearch">
      <app-download-banner></app-download-banner>
    </div>

    <div class="manage-templates">
      <h3 style="display: flex; justify-content: flex-start; align-items: center; gap: 5px">
        <span *ngIf="!fromSearch">Manage</span>
        <span *ngIf="fromSearch">FlyPlates</span>

        <!-- P8: the whole heading is bold and single-tone (master's h3 computes
             to 700 across every word); the trailing-span-only emphasis was a
             migration artifact. Weight now comes from the h3 rule in
             templates.component.scss. -->
        <span *ngIf="!fromSearch">FlyPlates</span>
        <vng-icon name="help_center" [outline]="false" color="purple" class="help-icon"
          ngbPopover="Here you can find FlyPlates (aka Templates) for multiple occasions, all written by us for your use immediately. Make sure to click “Add To FlyCuts”!">
        </vng-icon>
      </h3>

      <div class="manage-templates-actions">
        <button id="addAllTemplates" *ngIf="categoryId != 'all'" id="addNewCategory" type="button" vng-button
          variant="primary" (click)="templateCategoryCopyToShortcut()" [ngClass]="{ 'all-add': !downScroll }">
          <!-- V4-03: vng-icon's `:host` default color="plum" beats the primary
               button's inherited white, and vng-icon has no intrinsic font-size —
               the leading plus rendered #2A1E36 at 8x8 ink on the orange fill
               where master drew a white 14x14 plus. color="inherit" + master's
               mat-icon 24px em restore both. -->
          <vng-icon name="add" [outline]="false" color="inherit" [size]="24"></vng-icon> Add All FlyPlates
        </button>
      </div>
    </div>

    <!-- <div class="empty-state" *ngIf="!listService.isLoading && !templateList.length">
        <svg-icon-sprite width="500px" src="icon-ico-empty">
        </svg-icon-sprite>
        <div>
            <h3>No FlyPlates Added</h3>
            <label>Let get you started.</label>
        </div>
    </div> -->

    <div [ngClass]="listService.isLoading ? 'blur-effect' : ''" *ngIf="templateList.length">
      <!-- R15: mat-accordion multi -> plain div (all fe accordions are `multi`,
           so independent vng-expansion-panels need no coordination code). -->
      <div class="vng-accordion">
        <div class="relative" *ngFor="let template of templateList; let i = index">
          <div class="number absolute" style="background-color: unset">
            {{ i + 1 }}
          </div>
          <!-- C3-9: the onboarding tour used to force-expand the first/target
               panel imperatively via ViewChildren + MatExpansionPanel.open()
               (no such API on vng-expansion-panel). [expanded] is bound to the
               same panelOpenState flag that already gates the lazy-rendered
               editor below — setting panelOpenState[tf.id]=true in the tour
               init (templates.component.ts) now also visually expands the
               panel; normal user clicks continue to self-manage via the
               panel's own internal toggle() + (opened) emit, unaffected. -->
          <vng-expansion-panel [expanded]="panelOpenState[template.id]" (opened)="panelOpenState[template.id] = true"
            style="margin: 0 0 15px 50px">
            <!-- T3: shared collapsed-row content. FlyPlates rows have no
                 version/usage badge (showUsageBadge false) — titleHtml/
                 descriptionHtml run the HighlighterPipe unconditionally
                 (searchText is "" outside search mode, a no-op), matching the
                 pre-T3 markup exactly. -->
            <app-flymsg-row-header vngExpansionHeader [name]="template.shortcut" [premium]="template?.premium"
              [titleHtml]="template.title | highlighter : searchText : 'partial'"
              [descriptionHtml]="template.first_line | highlighter : searchText : 'partial'"
              [showUsageBadge]="false"></app-flymsg-row-header>

            <!-- T3: shared expanded-row content. FlyPlates rows are read-only
                 previews (no autosave/version column/action select/Duplicate-
                 ChangeCategory-Delete footer) — the FlyCut field keeps its
                 help icon here (flyCutHelpText), unlike shortcuts/dashboard.
                 The premium-watermarked TinyMCE <editor> stays fully
                 host-owned and is projected in via [editor]; the custom
                 Add/Reset/Update footer (incl. the dynamic step17+id tour
                 anchor) stays host markup below, since it has no equivalent
                 in the shared footer. -->
            <app-flymsg-row-editor [flyCutValue]="template.shortcut" [flyCutDisabled]="true" [flyCutRequired]="false"
              [flyCutHelpText]="'This is a shortcode or a keyboard shortcut that you’ll type when you want the content in the FlyMSG section below to be inserted onto any  enabled web platform.'"
              [showTryItOut]="false" [titleValue]="template.title" [titleDisabled]="true" [titleRequired]="false"
              [showVersionColumn]="false" [showActionSelect]="false" [showSavingNote]="false"
              [showDefaultActions]="false">
              <editor editor [apiKey]="editorApiKey" [cloudChannel]="'8'" [init]="editorConfig"
                *ngIf="editorConfig && panelOpenState[template.id]" [(ngModel)]="template.html"
                [ngModelOptions]="{ standalone: true }" [disabled]="true" class="disabled noselect"></editor>
            </app-flymsg-row-editor>

            <!-- R15: mat-action-row -> footer markup inside the body (panel body is
                 still *ngIf-live only while expanded, which is fine — this footer
                 is only ever visible/relevant while the panel is open anyway). -->
            <div class="panel-action-row" style="display: flex; flex-direction: column">
              <div class="template-action-footer-row">
                <div [ngClass.xs]="'button-row'" [ngClass.gt-xs]="'right-gap'" class="description"
                  *ngIf="template.action == 'add'">
                  <div class="circle primary"></div>
                  <!-- New template. Does not exist in your shortcut. -->
                  <strong>Not Added: </strong> This FlyPlate has not yet been added to your FlyCuts.
                </div>
                <div [ngClass.xs]="'button-row'" [ngClass.gt-xs]="'right-gap'" class="description"
                  *ngIf="template.action == 'reset'">
                  <div class="circle green"></div>
                  <!-- Exists in your shortcut already. -->
                  <strong>Added & Updated: </strong>This FlyPlate has been added to your FlyCuts.
                </div>

                <div [ngClass.xs]="'button-row'" [ngClass.gt-xs]="'right-gap'" class="description"
                  *ngIf="template.action != 'reset' && template.action != 'add'">
                  <div class="circle green"></div>
                  <strong>Added & Updated: </strong>
                  This FlyPlate has been added to your FlyCuts.
                  <!-- Updated template. Overwrite your shortcut copy. -->
                </div>

                <button *ngIf="template.action != 'reset' && template.action != 'add'" type="button" vng-button
                  variant="primary" (click)="resetTemplate(template, false)">
                  Update In My FlyCuts
                </button>

                <button *ngIf="template.action == 'reset'" type="button" vng-button variant="primary"
                  (click)="resetTemplate(template)">
                  Reset In My FlyCuts
                </button>

                <button *ngIf="template.action == 'add'" type="button" vng-button variant="primary"
                  [vngTourAnchor]="'step17' + template.id"
                  [attr.data-fms-heap]="isOnboarding ? 'walk-me-modal-step-13-add-to-flycuts' : ''"
                  (click)="addTemplateToShortcut(template)">
                  <!-- V4-03: the row-level twin of the "Add All FlyPlates" CTA above
                       (same plum-plus-on-orange defect); it is the button
                       `_t.tour.step18` captures. -->
                  <vng-icon name="add" [outline]="false" color="inherit" [size]="24"></vng-icon>
                  Add To FlyCuts
                </button>
              </div>
            </div>
          </vng-expansion-panel>
        </div>
      </div>
    </div>

    <div #bottom style="display: flex; justify-content: flex-end; align-items: center">
      <button type="button" vng-button variant="ghost" class="no-color scroll-button"
        (click)="scrollService.scrollTo(top)" id="scroll-up">
        <svg-icon-sprite width="14px" height="14px" src="icon-ico-scroll-up"> </svg-icon-sprite>
      </button>
    </div>
  </div>
</div>